import type { SupportedLanguage } from "../core/i18n";

/**
 * Converts a path to include language prefix only if the language is not English.
 * For English (en), returns the path without language prefix.
 * For other languages, returns the path with language prefix.
 *
 * @param path - The path to convert (e.g., "/discover", "/tag/example")
 * @param language - The current language code
 * @returns The path with appropriate language prefix
 *
 * @example
 * getLocalizedPath("/discover", "en") // returns "/discover"
 * getLocalizedPath("/discover", "zh") // returns "/zh/discover"
 * getLocalizedPath("/tag/example", "en") // returns "/tag/example"
 * getLocalizedPath("/tag/example", "fr") // returns "/fr/tag/example"
 */
export function getLocalizedPath(
  path: string,
  language: SupportedLanguage,
): string {
  // Ensure path starts with /
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  // If language is English, return path without prefix
  if (language === "en") {
    return normalizedPath;
  }

  // For other languages, add language prefix
  return `/${language}${normalizedPath}`;
}
